module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column medium-12"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.username')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "autocomplete": "off",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column medium-12"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('common.password')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "off",
      "disabled": _vm.loading
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keypress": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.login($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row log-in-btn"
  }, [_c('div', {
    staticClass: "column medium-12"
  }, [_c('transition', {
    attrs: {
      "name": "slide-down"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.errorMessage),
      expression: "!!errorMessage"
    }],
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.errorMessage))])]), _vm._v(" "), _c('a', {
    class: ['op-btn btn-lg btn-success btn-block', {
      'disabled': _vm.loading
    }],
    on: {
      "click": _vm.login
    }
  }, [(_vm.loading) ? _c('span', [_c('i', {
    staticClass: "fas fa-spinner fa-spin fa-fw"
  }), _vm._v(_vm._s(_vm.$t('common.loading')) + "\n        ")]) : _c('span', [_vm._v(_vm._s(_vm.$t('common.login')))])])], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0841847b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0841847b","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchForm/LoginForm.vue
// module id = 2030
// module chunks = 0